import { TEAM, SERVICE } from './config'
import { createLoggingService } from '@otto-ec/eprivacy-measures'

export const loggingService = createLoggingService(TEAM, SERVICE)
